import { serverWorker } from "./server-mock";

export const worker = serverWorker;
